import {
    REMOVE_WEB_SOCKET_ERROR_SENT_TIME,
    WEB_SOCKET_ERROR_SENT_TIME,
} from '../../actions/configuration';

const webSocketErrorSentTime = (state = null, action = undefined) => {
    switch (action.type) {
        case WEB_SOCKET_ERROR_SENT_TIME:
            return action.payload;
        case REMOVE_WEB_SOCKET_ERROR_SENT_TIME:
            return null;
        default:
            return state;
    }
};

export default webSocketErrorSentTime;
